import React from 'react';
import { Container } from 'reactstrap';

const AboutUs=()=>{
    return(
        <div>
            <h2>About Us</h2>
            <Container className='jumbotron'>
                <p> We are building a Courses Application. Here we have different courses on a variety of 
                    topics so that students can learn according to their interests.</p>
            </Container>
        </div>
    );
}

export default AboutUs;